import { useEffect, useState } from 'react';

import { PaymentMethodDto } from '@eneco/dc-be/client/types.gen';

import { useOrderId } from '../hooks/useOrderId';
import { useSelectedProducts } from '../hooks/useSelectedProducts';

const useCheckLossOfPromo = ({ paymentMethod }: { paymentMethod: PaymentMethodDto }) => {
  const orderId = useOrderId();

  const [hasLossOfPromo, setHasLossOfPromo] = useState(false);

  const { selectedProducts, orderPromos: orderPromo } = useSelectedProducts({
    orderId,
  });

  const hasDirectDebitRequired = selectedProducts?.promoDisclaimers?.some(promo => promo?.hasDirectDebit);

  useEffect(() => {
    if (!selectedProducts?.totalYearlyPriceWithNonCondtitionalPromo) {
      setHasLossOfPromo(false);
    } else if (paymentMethod !== 'DirectDebit' && hasDirectDebitRequired) {
      setHasLossOfPromo(true);
    } else {
      setHasLossOfPromo(false);
    }
  }, [paymentMethod, hasDirectDebitRequired, selectedProducts?.totalYearlyPriceWithNonCondtitionalPromo, orderPromo]);

  return { hasLossOfPromo };
};

export default useCheckLossOfPromo;
